import React from 'react';

const HeartContext = React.createContext();

export default HeartContext;
